import Image from "next/image";
import React from "react";

const WorkCard = ({ work }: { work: Work }) => {
  return (
    <aside className="flex flex-col gap-4">
      <div className="block sm:hidden">
        <Image
          src={work.image}
          alt={work.title}
          height={400}
          width={400}
          className="object-cover h-[20rem] rounded"
        />
      </div>
      <div className="hidden sm:block sm:w-[160px] xl:h-[262px] xl:w-[219px] 2xl:hidden">
        <Image
          src={work.image}
          alt={work.title}
          height={262}
          width={180}
          className="object-cover rounded-lg  sm:w-[160px] xl:h-[262px] xl:w-[219px]"
        />
      </div>
      <div className="hidden 2xl:block h-[362px] w-[269px]">
        <Image
          src={work.image}
          alt={work.title}
          height={362}
          width={269}
          className="object-cover rounded-lg h-[362px] w-[269px]"
        />
      </div>
      <div className="flex flex-col gap-2">
        <span className="h-[1px]  w-[180px] sm:w-[160px] bg-zinc-300 sm:bg-zinc-950 2xl:w-[269px]" />
        <h3 className="2xl:text-lg">{work.title}</h3>
      </div>
    </aside>
  );
};

export default WorkCard;
